module.exports = __webpack_public_path__ + "img/blank.964cc701.png";